import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormSectionControlComponent } from '../form-section-control/form-section-control.component';
import {ButtonModule} from 'primeng/button';
import { ConfigurationType, ControlType, FormPage, VisibleControls } from '../../../shared';
import { FormCreatorService, IConfigurationSection } from '../../../services';
import { TranslateModule } from '@ngx-translate/core';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-form-section-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormSectionControlComponent, 
    ButtonModule, TranslateModule, SplitButtonModule ],
  templateUrl: "./form-section-page.component.html"
})
export class FormSectionPageComponent {
  @Input() page !: FormPage;
  @Input() pageIndex !: number;
  @Input() formGroup !: FormGroup;
  @Input() isDesigner !: boolean;
  @Output() deletePageEvent = new EventEmitter<number>();
  @Output() createNewControlEvent = new EventEmitter<{pageIndex: number, type: ControlType | undefined}>();

  configurationType = ConfigurationType;

  VisibleControls: MenuItem[] = [];
  
  constructor(public fc: FormCreatorService) { 
    this.VisibleControls = VisibleControls.map(control => ({
      ...control,
      command: () => {
        this.onCreateNewControl(control.id, this.pageIndex);
      }
    }));
  }

  onDeletePage(pageIndex: number) {
    this.deletePageEvent.emit(pageIndex);
  }

  onCreateNewControl(typeString: string | undefined, pageIndex: number) {
    const type = typeString ? typeString as ControlType : undefined;
    this.createNewControlEvent.emit({pageIndex: pageIndex, type: type});
  }

  onShowConfiguration(event: Event, type: ConfigurationType, page: FormPage) {
    event.stopPropagation();
    if (!this.isDesigner) return
    const configuration = { show: true, type: type, page: page } as IConfigurationSection;
    this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
  }

  handleKey(event: KeyboardEvent, type: ConfigurationType, page: FormPage): void {
    event.stopPropagation();
    if (!this.isDesigner) return
    if (event.key === 'Enter' || event.key === ' ') {
      const configuration = { show: true, type: type, page: page } as IConfigurationSection;
      this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
    }
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }
}
